export const PRINTED_ADOPTION = 'printed-adoption';
export const HANDOFF_ADOPTION = 'handoff-adoption';
